module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded"
  }, [_c('el-col', {
    attrs: {
      "align": "left"
    }
  }, [(!_vm.hidePanel) ? _c('edit-pane', {
    ref: "ep",
    attrs: {
      "prefix": "Payment: ",
      "title": _vm.form.summary,
      "adding": true,
      "is-edit": _vm.editMode
    },
    on: {
      "save": _vm.onSave,
      "cancel": _vm.onCancel,
      "edit": _vm.onEdit,
      "add": _vm.onAdd
    }
  }) : _vm._e(), _vm._v(" "), _c('el-form', {
    attrs: {
      "model": _vm.form,
      "inline": true,
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 8
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('date-input', {
    attrs: {
      "label": _vm.dueDate,
      "placeholder": "Paid Date",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.date),
      callback: function($$v) {
        _vm.$set(_vm.form, "date", $$v)
      },
      expression: "form.date"
    }
  }), _vm._v(" "), _c('text-input', {
    attrs: {
      "label": "Reference No.",
      "placeholder": "Paid Ref",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.ref),
      callback: function($$v) {
        _vm.$set(_vm.form, "ref", $$v)
      },
      expression: "form.ref"
    }
  }), _vm._v(" "), _c('currency-input', {
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.amount),
      callback: function($$v) {
        _vm.$set(_vm.form, "amount", $$v)
      },
      expression: "form.amount"
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Taxable"
    }
  }, [_c('check-box', {
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.taxable),
      callback: function($$v) {
        _vm.$set(_vm.form, "taxable", $$v)
      },
      expression: "form.taxable"
    }
  })], 1), _vm._v(" "), (_vm.showTax()) ? _c('el-form-item', {
    attrs: {
      "label": _vm.taxLabel
    }
  }, [_c('b', [_vm._v(_vm._s(this.formatNumber(this.tax, 2)))])]) : _vm._e(), _vm._v(" "), (_vm.showTax()) ? _c('el-form-item', {
    attrs: {
      "label": "TOTAL"
    }
  }, [_c('b', [_vm._v(_vm._s(this.formatNumber(this.totals, 2)))])]) : _vm._e()], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b5e2585a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/property/LandownerPayment.vue
// module id = 1619
// module chunks = 0